import React from "react";
import "../../../styles/contact.css";

import { ICONS } from "../../../../../assets/icons";
import MessageStatus from "./MessageStatus";
import Avatar from "../../../../../components/commonComponents/avatar/Avatar";
import { Skeleton, Table } from "antd";

const BrandStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const ContactTable = ({
  contactList,
  isLoading,
}) => {
  const broadcastContactData = contactList?.broadcast_contacts;

  const payment_enabled = contactList?.payment_broadcast;

  const columns = React.useMemo(() => {
    const baseColumns = [
      {
        title: <span className=" header_names w-[15vw] "> First name</span>,
        dataIndex: "first_name",
        key: "first_name",
        render: (_, item) => (
          <div className="flex-row align-center">
            <div className=" w-[15vw] flex-row align-center">
              <div className="">
                {item?.role ? (
                  <Avatar
                    key={item?.id}
                    name={item?.role}
                    style={{
                      backgroundColor: item?.color,
                      color: "white",
                      padding: "2px",
                      fontSize: "22px",
                      fontWeight: "400",
                      borderRadius: "50%",
                      width: "38px",
                    }}
                  />
                ) : (
                  <img src={ICONS?.NoImageIcon} />
                )}
              </div>
              <span className=" header_right pl-2">
                {item?.first_name === null ? " -- " : item?.first_name}
              </span>
            </div>
          </div>
        ),
      },
      {
        title: <span className=" header_names w-[10vw]">Last name</span>,
        dataIndex: "last_name",
        key: "last_name",
        render: (_, item) => (
          <span className=" header_right w-[15vw] pl-2">
            {item?.last_name === null ? " -- " : item?.last_name}
          </span>
        ),
      },
      {
        title: <p style={BrandStyle}>Segment</p>,
        dataIndex: "broadcast_part_segment_id",
        key: "segment",
        render: (_, item) => (
          <div
            className="flex-row contact-segment align-center"
            style={BrandStyle}
          >
            <img
              src={ICONS?.BroadcastNewSegmentIcon}
              className="contact-segment-img"
            />

            <p className="pl-10">Segment -{item?.broadcast_part_segment_id}</p>
          </div>
        ),
      },
      {
        title: <p style={BrandStyle}>Mobile number</p>,
        dataIndex: "mobile_number",
        key: "mobile_number",
        render: (_, item) => (
          <p className=" flex-row" style={BrandStyle}>
            {/* {formatPhoneNumber(item?.to_number)} */}
            {`(+${item?.phone_country_code}) ${item?.mobile_number}`}
          </p>
        ),
      },
      {
        title: <p style={BrandStyle}> Message Status</p>,
        dataIndex: "status",
        key: "status",
        render: (_, item) => (
          <p className=" flex-row" style={BrandStyle}>
            <MessageStatus status={item?.status} />
          </p>
        ),
      },
    ];

    if (payment_enabled) {
      baseColumns.push(
        {
          title: <p style={BrandStyle}> Order ID</p>,
          dataIndex: "order_id",
          key: "order_id",
          render: (_, item) => (
            <p className=" flex-row pl-20" style={BrandStyle}>
              {item?.reference_id}
            </p>
          ),
        },
        {
          title: <p style={BrandStyle}> Payment Status</p>,
          dataIndex: "payment_status",
          key: "payment_status",
          render: (_, item) => {
            let statusText = '';
            let statusClass = '';
            
            switch(parseInt(item?.payment_status)) {
              case 10:
                statusText = 'Completed';
                statusClass = 'payment-status-completed';
                break;
              case 5:
                statusText = 'Pending';
                statusClass = 'payment-status-pending';
                break;
              case -1:
                statusText = 'Failed';
                statusClass = 'payment-status-failed';
                break;
              default:
                statusText = item?.payment_status || 'N/A';
                statusClass = 'payment-status-unknown';
            }
            
            if (parseInt(item?.payment_status) === -10) {
              return (
                <div className="flex-row pl-20" style={BrandStyle}>
                  --
                </div>
              );
            }

            return (
              <div className="flex-row pl-20" style={BrandStyle}>
                <span className={`payment-status-tag ${statusClass}`}>
                  {statusText}
                </span>
              </div>
            );
          },
        },
        {
          title: <p style={BrandStyle}> Total Amount</p>,
          dataIndex: "total_amount",
          key: "total_amount",
          render: (_, item) => (
            <p className=" flex-row pl-20" style={BrandStyle}>
              {item?.total_amount}
            </p>
          ),
        },
      );
    }

    return baseColumns;
  }, [payment_enabled]);


  return (
    <div className=" flex-column ">
      <div className="contact_table flex-column">
        <Skeleton active loading={isLoading} rootClassName="w-[98.5%]">
          <div className="contact_data">
            <Table
              columns={columns}
              dataSource={broadcastContactData ?? []}
              pagination={false}
              rowClassName={() => "contact_table_wrapper"}
              rowKey={(item) => item?.id ?? item?.mobile_number}
              scroll={{ y: "calc(60vh - 40px)" }}
              sticky
              tableLayout="fixed"
            />
          </div>
        </Skeleton>
      </div>
    </div>
  );
};

export default ContactTable;
